import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header align-items-center border-0 mt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-boldest text-dark fs-2" }, "My Competitors"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 mt-2 fw-bold fs-6" }, "More than 400+ new members")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-icon-primary btn-active-light-primary me-n3",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body pt-5" }
const _hoisted_7 = { class: "symbol symbol-60px symbol-2by3 me-4" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "d-flex align-items-center flex-wrap flex-grow-1 mt-n2 mt-lg-n1" }
const _hoisted_10 = { class: "d-flex flex-column flex-grow-1 my-lg-0 my-2 pe-3" }
const _hoisted_11 = {
  href: "#",
  class: "fs-5 text-gray-800 text-hover-primary fw-boldest"
}
const _hoisted_12 = { class: "text-gray-400 fw-bold fs-7 my-1" }
const _hoisted_13 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" By: ")
const _hoisted_15 = {
  href: "#",
  class: "text-primary fw-bold"
}
const _hoisted_16 = { class: "text-end py-lg-0 py-2" }
const _hoisted_17 = { class: "text-gray-800 fw-boldest fs-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fs-7 fw-bold d-block" }, "Sales", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass([`mb-${item.space}`, "d-flex"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: item.image,
              class: "mw-100",
              alt: ""
            }, null, 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, _toDisplayString(item.title), 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(item.description), 1),
              _createElementVNode("span", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("a", _hoisted_15, _toDisplayString(item.text), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(item.number), 1),
              _hoisted_18
            ])
          ])
        ], 2))
      }), 128))
    ])
  ], 2))
}